import GenericTemplate from "../Common/GenericTemplate";

// the sub-path and sub-components mapping are in src/Config/routes.js
const AdminPage = () => {
  const menuItems = [
    { label: "Platform", icon: "pi pi-server", path: "platform" },
    { label: "Users", icon: "pi pi-users", path: "users" },
  ];

  return <GenericTemplate menuItems={menuItems} />;
};

export default AdminPage;